module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3461591.fb424763.png";